import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { sub } from 'date-fns';
import { useEffect, useState } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { Icon, IconButton } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PiAfEventReaderService from 'app/admin/piAfEventReader/service/PiAfEventReaderService';
import EditFormDateTimeField from 'modules/ui/editform/fields/EditFormDateTimeField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';

function PiAfEventReaderQuery(props) {
	const piAfEventReaderName = props.piAfEventReaderName || null;
	const { t } = useTranslation(['common', 'validation']);
	const [loading, setLoading] = useState(false);
	const [items, setItems] = useState([]);

	useEffect(() => {
		PiAfEventReaderService.getListSelection()
			.then(response => setItems(response))
			.catch(() => setItems([]));
	}, []);

	const schema = yup.object().shape({
		name: yup.mixed().nullable().required(t('validation:FIELD_REQUIRED')),
		start_date_time: yup.date().nullable().required(t('validation:FIELD_REQUIRED')),
		end_date_time: yup.date().nullable().required(t('validation:FIELD_REQUIRED'))
	});

	const methods = useForm({
		defaultValues: {
			name: piAfEventReaderName,
			start_date_time: sub(new Date(), { weeks: 1 }),
			end_date_time: new Date()
		},
		mode: 'onChange',
		resolver: yupResolver(schema)
	});

	const handleSearch = dto => {
		const selected = items.find(item => String(item.id) === String(dto.name));
		const readerId = selected?.id ?? dto.name;

		setLoading(true);
		props.onResult(null);
		PiAfEventReaderService.get(readerId, {
			start_date_time: dto.start_date_time,
			end_date_time: dto.end_date_time
		})
			.then(response => props.onResult(response))
			.catch(() => props.onResult(null))
			.finally(() => setLoading(false));
	};

	return (
		<FormProvider {...methods}>
			<div className="flex flex-row">
				<div className="flex flex-1 flex-row mr-12">
					<Controller
						control={methods.control}
						name="name"
						render={({ field, fieldState }) => (
							<EditFormSelectField
								field={field}
								fieldState={fieldState}
								config={{ topic: 'piAfEventReader' }}
								fieldConfig={{
									className: 'mr-8',
									key: 'name',
									readOnly: piAfEventReaderName != null,
									items: () => PiAfEventReaderService.getListSelection()
								}}
							/>
						)}
					/>
					<Controller
						control={methods.control}
						name="start_date_time"
						render={({ field, fieldState }) => (
							<EditFormDateTimeField
								field={field}
								fieldState={fieldState}
								config={{ topic: 'piAfEventReader' }}
								fieldConfig={{ className: 'ml-8 mr-8', key: 'start_date_time' }}
							/>
						)}
					/>
					<Controller
						control={methods.control}
						name="end_date_time"
						render={({ field, fieldState }) => (
							<EditFormDateTimeField
								field={field}
								fieldState={fieldState}
								config={{ topic: 'piAfEventReader' }}
								fieldConfig={{ className: 'ml-8', key: 'end_date_time' }}
							/>
						)}
					/>
				</div>
				<div className="mt-12">
					<IconButton onClick={() => methods.handleSubmit(handleSearch)()} disabled={loading}>
						<Icon>search</Icon>
					</IconButton>
				</div>
			</div>
		</FormProvider>
	);
}

export default PiAfEventReaderQuery;
